interface IInfoCard {
  title: string;
  category: string;
  description: string;
  changePerc?: number; // Optional percentage for price volatility
}

const InfoCard = (props: IInfoCard) => {
  const { title, category, description, changePerc } = props;

  // Determine if this is a price volatility card (has changePerc)
  const isPriceVolatility = changePerc !== undefined;

  if (isPriceVolatility) {
    // Use AlertCard-style layout for price volatility
    return (
      <div className="flex w-full flex-col mobile:flex-row justify-between rounded-lg border-[1px] border-border-color p-3">
        <div className="flex flex-row items-center gap-4">
          <div
            className={`h-[12px] w-[12px] rounded-full ${
              changePerc < 0 ? 'bg-primary-green' : 'bg-primary-red'
            }`}
          />
          <div>
            <h4 className="text-headings-font-color">{title}</h4>
            <span className="flex items-center gap-1 text-font-color">
              <p className="text-sm">{category}</p>
            </span>
          </div>
        </div>
        <div className="flex flex-col mobile:items-end ml-6 mt-2">
          <h4
            className={`text-lg font-bold ${
              changePerc < 0 ? 'text-primary-green' : 'text-primary-red'
            }`}
          >
            {changePerc > 0 && '+'}
            {changePerc}%
          </h4>
          <p className="text-sm text-font-color">{description}</p>
        </div>
      </div>
    );
  }

  // Original layout for other use cases
  return (
    <div className="rounded-lg border-[1px] border-border-color p-3">
      <span className="flex items-center gap-4">
        <h4 className="text-base font-medium text-headings-font-color">{title}</h4>
        <span className="rounded-full bg-[#F5F5F5] px-3 py-2 text-xs capitalize">{category}</span>
      </span>
      <div className="mt-1 text-xs text-font-color">{description}</div>
    </div>
  );
};

export default InfoCard;
